import React, { useState, useEffect } from 'react';

function IconChevron(props) {
    return (
        <> 
           {props.isopen ? (<i className="atm-icon chevron-down"/>) : (<i className="atm-icon chevron-right"/>
            ) }
        </>
    )
}

export default IconChevron;
